<div class="container-fluid tp-box" [@flipState]="flip" >
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">login</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">{{ title }}</span>
				</div>
			</div>
			<div class="cw-body"  *ngIf="viewing">
				<div class="table">
				<table class="table table-fixed table-striped table-hover table-fluid w-100" #print_table>
					<thead>
					<tr>
						<th>Order#</th>
						<th>Status</th>
						<th>Date</th>
						<th>Customer#</th>
						<th>Name</th>
						<th>Salesperson</th>
						<th>Entered by</th>
						<th>Items </th>
						<th>SubTotal</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let d of data">
						<td>{{ d.orderno}}</td>
						<td>{{ d.status}}</td>
						<td>{{ d.deliverydate}}</td>
						<td><a [routerLink]="'/customers/view/'+d.debtorno">{{ d.debtorno }}.{{ d.branchcode }}</a></td>
						<td>{{ d.deliverto}}</td>
						<td>{{ d.salesperson_name || d.details?.quote_salesperson_name || d.details?.salesmanname || '—' }}</td>
						<td>{{ d.enteredby_line || d.details?.quote_enteredby_name || d.details?.enteredby || '—' }}</td>
						<td>{{ d.items}}</td>
						<td>{{ d.subtotal | currency}}</td>
					</tr>
					</tbody>
				</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				[title]="title"
				icon="request_quote"
				accent="primary"
				[value]="data ? data.length : null"
				[loading]="!data"
				(view)="toggleFlip(data, title)">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
